const FourOhFour = () => {
  return (
    <div>
      <h1>Sorry, that page does not exist!</h1>
    </div>
  )
};

export default FourOhFour;